// Mock data for South Florida Caregivers LLC (frontend-only)

export const company = {
  name: "South Florida Caregivers",
  legal: "South Florida Caregivers LLC",
  tagline: "Compassionate Care. A Brighter Tomorrow.",
  phone: "954 871 5843",
  phoneLink: "9548715843",
  email: "Alli@soflocaregivers.com",
  website: "www.soflocaregivers.com",
  websiteLink: "https://www.soflocaregivers.com",
  address: "13833 Wellington Trace, Ste E4 #678, Wellington, FL 33414",
  hours: "Monday \u2013 Saturday: 9:00 AM \u2013 9:00 PM",
  logo: "/assets/sfc_logo.png",
};

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Service", href: "#services" },
  { label: "Contact Us", href: "#contact" },
];

export const heroSlides = [
  {
    eyebrow: "Welcome",
    title: "Your Health And Comfort",
    highlight: "is our concern.",
    text: "We customize care plans that are right for your loved ones.",
    image:
      "https://images.unsplash.com/photo-1765896387387-0538bc9f997e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxudXJzZSUyMGNhcmluZyUyMGVsZGVybHklMjB3b21hbnxlbnwwfHx8fDE3ODk4NDg5Njl8MA&ixlib=rb-4.1.0&q=85&w=1920",
  },
  {
    eyebrow: "Loving In-Home Care",
    title: "Compassionate Care",
    highlight: "for the ones you love.",
    text: "Trusted caregivers providing dignified, personalized support right at home.",
    image:
      "https://images.pexels.com/photos/8949908/pexels-photo-8949908.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  },
  {
    eyebrow: "Nursing Care",
    title: "Around-The-Clock",
    highlight: "professional support.",
    text: "Qualified health care professionals dedicated to your family's wellbeing.",
    image:
      "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxudXJzZSUyMGJsb29kJTIwcHJlc3N1cmUlMjBzZW5pb3J8ZW58MHx8fHwxNzg5ODQ4OTI5fDA&ixlib=rb-4.1.0&q=85&w=1920",
  },
];

export const services = [
  {
    title: "Companionship",
    icon: "Users",
    color: "blue",
    desc: "Services that help with light housekeeping, meal preparation, errands, incidental transportation, recreational activities, and more.",
    image:
      "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBjb21wYW5pb25zaGlwJTIwc2VuaW9yfGVufDB8fHx8MTc4OTg0ODkyOXww&ixlib=rb-4.1.0&q=85&w=800",
  },
  {
    title: "Home Health Aide / CNA",
    icon: "HousePlus",
    color: "purple",
    desc: "Our aides assist people with disabilities, chronic illness, or cognitive impairment in their daily living activities.",
    image:
      "https://images.unsplash.com/photo-1773227055624-07b515ba87c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxob21lJTIwaGVhbHRoJTIwYWlkZSUyMGVsZGVybHl8ZW58MHx8fHwxNzg5ODQ4OTI5fDA&ixlib=rb-4.1.0&q=85&w=800",
  },
  {
    title: "Nursing Services",
    icon: "Stethoscope",
    color: "blue",
    desc: "We provide qualified health care providers to ensure the necessary services that promote health and wellness.",
    image:
      "https://images.pexels.com/photos/39192356/pexels-photo-39192356.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
  {
    title: "Postnatal Services",
    icon: "Baby",
    color: "purple",
    desc: "Compassionate care for mothers and their newborns immediately after birth and through the first weeks of life.",
    image:
      "https://images.unsplash.com/photo-1542385151-efd9000785a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxtb3RoZXIlMjBuZXdib3JuJTIwYmFieXxlbnwwfHx8fDE3ODk4NDg5Njl8MA&ixlib=rb-4.1.0&q=85&w=800",
  },
  {
    title: "Terminal Illness Care",
    icon: "HeartPulse",
    color: "blue",
    desc: "Comfort and dignity for the terminally ill through gentle, patient-centered, compassionate end-of-life care.",
    image:
      "https://images.unsplash.com/photo-1682352689072-7b2c0b8580c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxob3NwaWNlJTIwY29tcGFzc2lvbmF0ZSUyMGNhcmUlMjBlbGRlcmx5fGVufDB8fHx8MTc4OTg0ODkyOXww&ixlib=rb-4.1.0&q=85&w=800",
  },
  {
    title: "Live In Services",
    icon: "Clock",
    color: "purple",
    desc: "Around-the-clock in-home assistance for seniors who need continuous, dependable support day and night.",
    image:
      "https://images.pexels.com/photos/7551654/pexels-photo-7551654.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
  {
    title: "Homemaker / Nanny",
    icon: "Home",
    color: "blue",
    desc: "Extra coverage and flexibility for busy parents with trusted homemaker and nanny services you can rely on.",
    image:
      "https://images.pexels.com/photos/6974489/pexels-photo-6974489.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
  {
    title: "Personal Care",
    icon: "HandHeart",
    color: "purple",
    desc: "Improving quality of life by helping seniors with bathing, dressing, grooming, and mobility so they can thrive.",
    image:
      "https://images.pexels.com/photos/29372531/pexels-photo-29372531.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
  {
    title: "Home Assistant & Hospice Care",
    icon: "HeartHandshake",
    color: "blue",
    desc: "Dedicated home assistance and hospice support that brings comfort, care, and peace of mind to your family.",
    image:
      "https://images.pexels.com/photos/9893512/pexels-photo-9893512.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=800",
  },
];

// 8 features arranged around the nurse portrait (Why Choose Us)
export const whyFeatures = [
  { title: "Companionship", desc: "Services that help with light housekeeping, and more." },
  { title: "Home Health Aide / CNA", desc: "Our aides assist in their daily living activities." },
  { title: "Nursing Services", desc: "Providing qualified health care providers services." },
  { title: "Postnatal Services", desc: "Care for mothers and their newborns after birth." },
  { title: "Terminal Illness Care", desc: "Care for the terminally ill through compassionate care." },
  { title: "Live In Services", desc: "Seniors who need around-the-clock assistance." },
  { title: "Homemaker / Nanny", desc: "Providing extra coverage and flexibility for parents." },
  { title: "Personal Care (PC)", desc: "Improving the quality of life helping seniors to thrive." },
];

export const aboutStats = [
  { value: "9+", label: "Care Services" },
  { value: "24/7", label: "Available Support" },
  { value: "100%", label: "Compassion" },
];

export const trustBadges = [
  {
    icon: "UserRound",
    title: "Qualified Individuals We Hire",
    desc: "We hire only qualified personnel including CNA, HHA, RN, and LPN professionals.",
  },
  {
    icon: "ShieldCheck",
    title: "Licensed, Bonded & Insured",
    desc: "Our company is fully licensed, bonded, and insured for your complete peace of mind.",
  },
  {
    icon: "BadgeCheck",
    title: "We Accept Various Insurance",
    desc: "For more information on the payments and insurance we accept, please contact us.",
  },
];

export const testimonials = [
  {
    name: "Amy Walker",
    role: "Happy Client",
    text: "South Florida Caregivers has been a lifesaver for my family. My dad was feeling so lonely, and the companion care services brought joy back into his life. His caregiver spends time talking with him and even walking in the garden.",
  },
  {
    name: "Natalie Jones",
    role: "Happy Client",
    text: "When my mom was diagnosed and we felt overwhelmed, South Florida Caregivers stepped in with the expertise and compassion we desperately needed. The caregiver was incredibly patient, understanding, and kind.",
  },
  {
    name: "Karen S.",
    role: "Happy Client",
    text: "Taking care of my husband after his stroke left me depleted. Their personal and live-in care services changed everything \u2014 they helped with his daily needs and gave me time to breathe again.",
  },
  {
    name: "J. Parker",
    role: "Happy Client",
    text: "Your loved ones are in capable hands with this agency. They've covered everything my mom needs, from personal care to companionship. Her caregiver is kind and attentive, and Mom feels truly safe.",
  },
];
